import { IStaticPageItem } from '@ui';
import { cloneDeep } from 'lodash';

export const dataMobile: IStaticPageItem[] = [
  {
    title: 'Taboo - Setup',
    description: '',
    background: '',
    blocks: [
      {
        title: '',
        background: '',
        description: [
          {
            type: 'list',
            order: true,
            start: 1,
            value: [
              `
              Firstly, you’ll want to create a set of words for your learners to play. To do this, click ‘create game’.  Then select ‘Taboo’ from the games menu. This will take you to the create game page where you can setup the game.
              `,
              `
              Here, you’ll need to think about how many teams you’d like your class to be divided in. This will also affect the game mode you’ll choose a bit later on. If you have a small class, 2 teams might be manageable. However, with a larger class, you might prefer 4 or 6 teams.
              `,
              `
              Next, choose the maximum number of students per team. This can be changed later if some of your students are absent, or additional students come.
              `,
              `
              You then have some options for timing. You can choose to have no time limit with normal mode. The other option is a time limit, where you can set a time limit of between 1 - 5 mins for each turn.
              `,
              `
              The next thing to choose is the game mode. There are 2 options: whole class and chaotic mode. If you’ve selected more than 2 teams this will automatically be chaotic mode. Chaotic mode is where there are multiple sets of mini games occurring at once. Students have more control and get to decide whether to allocate points to their opponents or deduct them. On the other hand, in whole class mode, there is only one large game occurring and the teacher gets to decide whether students gain or lose a point.
              `,
              `
              Once you’ve set up the game modes, you can now start to build your word lists, these include the keyword and the ‘taboo’ banned words which the describers can’t say. Firstly, type in the keyword in the box, then type in the banned words below - these should be closely related to the keyword. You can add up to 5 banned words per word.
              `,
              `
              You can add more words by clicking ‘add more’. In whole class mode, there should be at least the same number of words as there are students playing, so that each student gets a unique word and no word is repeated. In chaotic mode, there can be fewer words than students, as there will be separate games occurring at the same time.
              `,
              `
              Once you’ve added all the words, you can either save the game for future use, or play it immediately. If you want to save the game first, click on ‘save to a folder’. If you have created a folder beforehand, you can save it to this folder. If not, you can save it to an unassigned folder. Note: you can always move saved games to folders later, in the home page.
              `,
              `
              If you’re ready to play the game live in your classroom, click on ‘launch game’. This will prompt you to name the game and choose the location where you want to save it. Once you’ve entered this information, click on ‘launch’.
              `
            ]
          }
        ],
        image: '',
        subTitle: ''
      },
      {
        title: '',
        subTitle: '',
        description: [],
        background: '',
        image: 'learn_more_taboo.png'
      },
      {
        title: '',
        background: '',
        description: [
          {
            type: 'list',
            order: true,
            start: 10,
            value: [
              `
              This will take you to the waiting room, where students can join via a link and a join code, or by scanning a QR code.
              `,
              `
              Once a student joins the game, they will randomly be assigned to a team. They do have an ability to switch teams. The teacher can also switch teams of any individual student. Note: if all teams are full, students joining will go to an ‘observations’ team, which is for students unassigned to a team.
              `,
              `
              Once all students have joined a team, click on ‘Start game!’
              `
            ]
          }
        ],
        image: '',
        subTitle: ''
      },
      {
        title: '',
        subTitle: '',
        description: [],
        background: '#ffffff',
        image: 'learn_more_taboo_2.png'
      }
    ],
    subTitle: '',
    titleStyle: ''
  },
  {
    title: 'Taboo - During Play',
    description: '',
    background: '',
    blocks: [
      {
        title: '',
        background: '',
        description: [
          {
            type: 'list',
            order: true,
            start: 1,
            value: [
              `
              Once you’ve started the game, students will be alerted on their phones (or other personal device) and they will be asked to press ‘ready’.
              `,
              `
              Once they’ve all clicked on ‘ready’ a student will be randomly selected to be a describer, while the other members of the team are guessers.
              `,
              `
              The describer will describe the word to their teammates without using a banned word. If playing chaotic mode, students from the opposite team will also get to see the keyword and banned word list - they will decide whether the student describing the word gains or loses a point. If playing whole class mode, the opposing team won’t get to see the banned word list as the teacher will be the one who decides whether to give the points or not.
              `,
              `
              Points are awarded by either the opposing students or the teacher. If playing whole class mode, the teacher is totally in control of awarding / deducting points each turn. In chaotic mode, the opposing students make the decision. To award / deduct points, click on ‘pause game’. From here there are 3 choices: gain point, lose point or resume game.
              `,
              `
              Once a student’s turn has ended, a student from the opposing team will be selected randomly to be the describer.
              `,
              `
              This will be repeated until all words will be described and every student has had a chance to be a describer.
              `,
              `
              Alternatively, the teacher can end the game early, before all words have been described by clicking ‘emergency end game’.
              `,
              `
              Once the game has ended, there will be a game review screen which shows all the words played in that game as well as the banned word lists.
              `,
              `
              The next screen is the score discussion. Scores will be calculated automatically during the game as points are gained / lost. However, if there are any disputes (e.g. a student has wrongfully deducted points by mistake), the teacher has a chance here to adjust the scores.
              `,
              `
              Once all scores are finalised, there will be a leaderboard displaying the scores of all teams who participated.
              `
            ]
          },
          {
            type: 'string',
            value: [
              'Note that if any students accidentally drop out at any point during the game, they are able to rejoin it by going to the same link, entering the same game code and entering the same name they used to enter previously. They’ll then need to click on ‘rejoin’. This will put them in the same group as they were previously.'
            ]
          }
        ],
        image: '',
        subTitle: ''
      }
    ],
    subTitle: '',
    titleStyle: ''
  }
];

const genDataDesktop = () => {
  const [setup, play] = cloneDeep(dataMobile);

  const setupBlocks = setup.blocks;

  setupBlocks[0].description[0].value =
    setupBlocks[0].description[0].value.concat(
      setupBlocks[2].description[0].value
    );

  setupBlocks[0].image = 'learn_more_taboo_3.jpg';
  setupBlocks[0].imageStyle = { marginTop: '-56px' };
  setupBlocks[0].row = true;

  setup.blocks = setup.blocks.slice(0, 1);

  return [
    setup,
    play,
    {
      title: 'Example round - Whole Class mode',
      description: '',
      background: '#83C0EC',
      blocks: [
        {
          title: '',
          background: '',
          description: [],
          image: 'taboo_guide_wholeclass.jpg',
          subTitle: '',
          imageFullWidth: true
        }
      ],
      subTitle: '',
      titleStyle: ''
    },
    {
      title: 'Example round - Chaotic mode',
      description: '',
      background: '#83C0EC',
      blocks: [
        {
          title: '',
          background: '',
          description: [],
          image: 'taboo_guide_chaotic.jpg',
          subTitle: '',
          imageFullWidth: true
        }
      ],
      subTitle: '',
      titleStyle: ''
    }
  ];
};

export const dataDesktop = genDataDesktop();
